import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Back-compat redirect: questionnaire management moved under the Admin area, so
 * old /questionnaires/* links now resolve to /admin/questionnaires/*, preserving
 * any deep drill-down path.
 */
export default function QuestionnairesRedirect() {
  const rest = useParams()['*'];
  return <Navigate to={`/admin/questionnaires${rest ? `/${rest}` : ''}`} replace />;
}
